export enum InfoSectionTheme {
	Info = 'info',
	Primary = 'primary',
}
